.metadataList {
    margin-bottom: 1em;
}

.metadataType {
    font-weight: 700;

    &::after {
        content: ": ";
    }
}

.metadataType,
.metadataValue {
    display: inline;
    margin: 0;
}

.note {
    font-style: italic;
}
